// disable auto-story

import { ComponentProps, useRef, useState } from 'react';
import BladeItem from './blade-item';
import useOnClickOutside from 'use-onclickoutside';

interface BladeLevelOptions {
  children?: { [key: string]: ComponentProps<typeof BladeItem> };
  className?: string;
  level?: number; // 0 indexed
  style?: React.CSSProperties;
}

/**
 * Represents one column of a subnav within a dropdown blade.
 * For example "Overview, Academic, Test Prep" within Tutoring, and then "1-on-1 Private Tutoring, Online Tutoring".
 * It handles rendering selected subnav in a flat structure. For this the Blade should have flex styling.
 */
function BladeLevel({ children, level = 0, style = {} }: BladeLevelOptions) {
  const [openBladeKey, setOpenBladeKey] = useState<string>();
  const areaRef = useRef(null);
  useOnClickOutside(areaRef, () => setOpenBladeKey(undefined));

  if (!children) return null;

  const multiColumnClasses =
    level > 0 && Object.entries(children).length > 11
      ? 'grid grid-cols-2 min-w-[380px]'
      : 'min-w-[190px]';

  return (
    <>
      <ul
        className={`flex flex-col mr-1 py-2 px-3 bg-white text-black shadow-md relative ${multiColumnClasses}`}
        ref={areaRef}
        style={style}
      >
        {Object.entries(children).map(([key, item]) => (
          <BladeItem
            isOpen={openBladeKey === key}
            key={key}
            level={level + 1}
            onOpen={() => setOpenBladeKey(key)}
            {...item}
          />
        ))}
      </ul>
    </>
  );
}

export default BladeLevel;
